<panel style="min-width: 400px">
  @if (!pool.id) {
    <h1>{{ 'pool.create-pool' | translate }}</h1>
  }
  @if (pool.id) {
    <h1>{{ 'pool.edit-pool' | translate }}</h1>
  }
  <section>
    <custom-input [label]="'pool.name' | translate"
      [placeholder]="'pool.name-placeholder' | translate"
      [(value)]="pool.name"
    [required]="true"></custom-input>
    <custom-input [label]="'pool.icon' | translate"
      [placeholder]="'pool.icon-placeholder' | translate"
      [(value)]="pool.icon"
    [required]="true"></custom-input>
    <custom-select [label]="'pool.query' | translate"
      [selectList]="queriesList"
      [placeholder]="'pool.query-placeholder' | translate"
      [required]="true"
      (valueChange)="selectQuery($event)"
    [value]="pool.queryId"></custom-select>
    <add-multiple [label]="'pool.teams' | translate"
      [placeholder]="'pool.teams-placeholder' | translate"
      [(selectedItems)]="addedTeams"
      [availableItems]="allTeams"
    [required]="true"></add-multiple>
  </section>
  @if (queryData && queryData.filters.length > 0) {
    <section>
      <h1>{{ 'pool.query-add-input' | translate }}</h1>
      @if (queryProperties && queryProperties.length > 0) {
        <div>
          <table style="width:100%">
            <tr>
              <th>{{ 'query.column.property' | translate }}</th>
              <th>{{ 'query.column.operator' | translate }}</th>
              <th>{{ 'query.column.input' | translate }}</th>
            </tr>
            @for (filter of queryData.filters; track filter) {
              <tr>
                <td>{{ filter.property?.name }}</td>
                <td>{{ 'query.operator.' + operatorType[filter.operator] | translate }}</td>
                <td>
                  @if (!isNullOperator(filter.operator)) {
                    <query-input
                      [propertyName]="filter.property?.name"
                      [queryProperties]="queryProperties"
                      [options]="getOptions(filter)"
                      [(value)]="filter.value">
                    </query-input>
                  }
                </td>
              </tr>
            }
          </table>
        </div>
      }
    </section>
  }
  <section>
    <button confirm #saveButton (click)="savePool()" [ignoreValidation]="true">{{ 'general.save' | translate }}</button>
  </section>
</panel>
